// extracted by mini-css-extract-plugin
module.exports = {"panel":"MainPanel_panel__3KWix"};